export default function MapControls({ recenterMap, startAdding }) {
  return (
    <>
      <button style={addButtonStyle} onClick={startAdding}>
        +
      </button>

      <button style={recenterStyle} onClick={recenterMap}>
        ⌖
      </button>
    </>
  );
}

/* ---------- Styles ---------- */

const addButtonStyle = {
  position: "fixed",
  bottom: "calc(350px + env(safe-area-inset-bottom))",
  right: "20px",
  width: "80px",
  height: "80px",
  borderRadius: "50%",
  fontSize: "30px",
  background: "rgba(255, 59, 48, 0.9)",
  backdropFilter: "blur(10px)",
  boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
  color: "white",
  border: "none",
};

const recenterStyle = {
  position: "fixed",
  bottom: "calc(450px + env(safe-area-inset-bottom))",
  right: "26px",
  width: "70px",
  height: "70px",
  borderRadius: "50%",
  background: "rgba(40, 40, 42, 0.8)",
  color: "white",
  backdropFilter: "blur(10px)",
  border: "none",
  fontSize: "20px",
  fontWeight: "bold",
  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
  zIndex: 500,
};